module.exports = __webpack_public_path__ + "img/dcfk_content1.a7e86fe9.png";